import React from 'react';
import styled from 'styled-components';

const Img = styled.img`
  display: ${ ({ inline }) => inline  ? 'inline' : 'block' };
  vertical-align: ${({ inline}) => inline ? '-8px' : 0 };
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default' };
`;

const Icon = ({ inline, name, label, clickable, ...props }) => {
  let icon = '';
  switch (name) {
    case "trash":
      icon="data:image/svg+xml,%3Csvg%20fill%3D%22%23ab3029%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M6%2019c0%201.1.9%202%202%202h8c1.1%200%202-.9%202-2V7H6v12zM19%204h-3.5l-1-1h-5l-1%201H5v2h14V4z%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%0A%3C/svg%3E";
      break;
    case "drag":
      icon="data:image/svg+xml,%3Csvg%20fill%3D%22%23000000%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0V0z%22%20id%3D%22a%22/%3E%0A%20%20%20%20%3C/defs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22b%22%3E%0A%20%20%20%20%20%20%20%20%3Cuse%20overflow%3D%22visible%22%20xlink%3Ahref%3D%22%23a%22/%3E%0A%20%20%20%20%3C/clipPath%3E%0A%20%20%20%20%3Cpath%20clip-path%3D%22url%28%23b%29%22%20d%3D%22M20%209H4v2h16V9zM4%2015h16v-2H4v2z%22/%3E%0A%3C/svg%3E"
      break;
    case "add":
      icon="data:image/svg+xml,%3Csvg%20fill%3D%22%23ab3029%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M19%2013h-6v6h-2v-6H5v-2h6V5h2v6h6v2z%22/%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%0A%3C/svg%3E";
      break;
    case "hint":
      icon="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZmlsbD0iI2ZmZTFiZiIgZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyczQuNDggMTAgMTAgMTAgMTAtNC40OCAxMC0xMFMxNy41MiAyIDEyIDJ6bTEgMTVoLTJ2LTZoMnY2em0wLThoLTJWN2gydjJ6Ii8+PC9zdmc+Cg==";
  }

  return <Img inline={ inline } src={icon} clickable alt={ label } {...props} />
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js